import { Injectable } from '@angular/core';
import { SettingsService } from '../common/settings.service';
import { AuthService } from './auth.service';
import { Http, Headers } from '@angular/http';

@Injectable()
export class AddSupervisorService {


    constructor(
        private settings: SettingsService,
        private authService: AuthService,
        private http: Http
    ) { }

    searchCompany(searchString: string) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverNomenclator + 'Company/Search?search=' + searchString, { headers: headers })
            .map(res => res.json());
    }

    searchInstitution(searchString: string) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverNomenclator + 'PublicInstitution/Search?criteria=' + searchString, { headers: headers })
            .map((res) => res.json());
    }

    addSupervisor(supervisor) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.post(this.settings.serverNomenclator + 'Supervisor/AddSupervisor', supervisor, { headers: headers })
            .map(res => res.json());
    }
}
